import React from 'react'

import { useSaveTag } from './_requests/saveTag'
import { useTag } from './_load/TagLoader'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditTagForm = () => {
  const tag = useTag()
  const [onSubmit, { loading, error }] = useSaveTag()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={tag || {}}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditTagForm
